const ERRORS = {
    state: 'state is not defined'
}

const errorLog = () => {

}

/**
 * @typedef {object} Slots
 * @param {object} [slots={}]
 * @param {object} [props={}]
 * @returns {Slots} typeof {Object} with used slots
 */
const useGetSlots = (slots = {}, props = {}) => {
    let result = {}

    for (let k in slots) {
        result[k] = (props) => slots[k](props)
    }

    return result
}




/**
 *
 *@deprecated in next release
 * @param {*} [state=[]]
 * @returns
 */
const useBuildState = (state = []) => {
    let result = [];

    if (state) {
        for (let k in state) {
            if (state[k]) {
                result.push(k)
            }
        }
    }
    return result
}
/**
 *@deprecated
 *
 * @param {*} defaultSlots
 * @param {*} slots
 * @returns
 */
const usePrepareSlots = (defaultSlots, slots) => {
    let data = {}
    for (let i = 0; i < defaultSlots.length; i++) {
        if (slots.hasOwnProperty(defaultSlots[i])) {
            data[defaultSlots[i]] = slots[defaultSlots[i]]
        } else {
            if (defaultSlots[i] !== 'default') {
                data[defaultSlots[i]] = () => void 0
            }
        }
    }

    return data
}

const useUUID = () => {
    if (typeof window === 'undefined') {
        return Math.random()//const crypto = import('crypto')
    }
    return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
        (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
    );
}

const useGetListeners = (listeners, ctx) => {
    let regex = /^on[A-Z]+/gu

    let result = {}

    if (listeners) {
        listeners.forEach((item) => {
            if (regex.test(item)) {
                result[item] = ($e) => {
                    ctx.emit($e.type)
                }
            }
        })
    }

    return result
}




/**
 *@deprecated
 *
 * @param {*} slot
 * @param {*} props
 * @returns
 */
const getSlot = (slot, props) => {
    if (slot) {
        console.log(slot)
        return slot(props)
    } else {
        console.log(slot)
        return ''
    }
}



export { useBuildState, usePrepareSlots, getSlot, useGetSlots, useUUID, useGetListeners }